import React from 'react';
import { Checkbox } from 'antd';
import moment from 'moment';
import { withTranslation } from 'react-i18next';

import useStartTimer from '../../../utils/hooks/useStartTimer.hook';
import { connect } from '../../StateProvider';

import styles from './timer.less';

const TimerLabel = ({ timeUntilTimerEnd, viewSettingsTimer: showTimer, t }) => {
  const { duration } = useStartTimer(timeUntilTimerEnd, showTimer, undefined);

  return (
    <div className={styles.containerTimer}>
      <Checkbox className={styles.settingIcon} defaultChecked={showTimer} checked={showTimer} />
      <span className={styles.autoUpdateTitle}>{t('timer.autoUpdate')}</span>
      <span className={styles.timer}>{duration && moment(duration).format('m:ss')}</span>
    </div>
  );
};

export default withTranslation()(
  connect(
    TimerLabel,
    {
      viewSettings: ['viewSettings', 'catalogs'],
    },
    (props, { viewSettings }) => {
      const timeUntilTimerEnd = props.scene && props.scene.get('timeUntilTimerEnd');
      const catalogViewSettings = viewSettings && viewSettings.getIn([props.catalogId, 'views', props.viewId, props.viewMode]);
      return {
        viewSettingsTimer: catalogViewSettings && catalogViewSettings.get('timer'),
        timeUntilTimerEnd,
        ...props,
      };
    },
  ),
);
